import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("munners_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Normalize Pydantic 422 errors so .detail is always a string the UI can render
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const data = err?.response?.data;
    if (data && Array.isArray(data.detail)) {
      const msgs = data.detail
        .map((d) => {
          const where = Array.isArray(d.loc) ? d.loc.filter((x) => x !== "body").join(".") : "";
          return `${where}${where ? ": " : ""}${d.msg || d.type || "invalid"}`;
        })
        .join("; ");
      err.response.data.detail = msgs;
    }
    return Promise.reject(err);
  }
);

export default api;
